module.exports = __webpack_public_path__ + "img/ATTACHMENT.0e2f8d6f.svg";